import { render } from "./SniplyPowerup.vue?vue&type=template&id=734436d2"
import script from "./SniplyPowerup.vue?vue&type=script&lang=js"
export * from "./SniplyPowerup.vue?vue&type=script&lang=js"

import "./SniplyPowerup.vue?vue&type=style&index=0&id=734436d2&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__